export var VehicleTypes;
(function (VehicleTypes) {
    VehicleTypes["USED"] = "used";
    VehicleTypes["NEW"] = "new";
    VehicleTypes["LEASE"] = "lease";
})(VehicleTypes || (VehicleTypes = {}));
export var CardTagType = /** @class */ (function () {
    function CardTagType(key, displayText) {
        this.displayText = '';
        this.key = key;
        this.displayText = displayText;
    }
    CardTagType.prototype.toString = function () {
        return this.key;
    };
    CardTagType.Default = new CardTagType('default', '');
    CardTagType.SpecialOffer = new CardTagType('special-offer', 'Special offer');
    CardTagType.InStock = new CardTagType('inStock', 'In stock');
    CardTagType.BlackFriday = new CardTagType('black-friday', 'Black Friday Exclusive');
    CardTagType.NewCar = new CardTagType('new-car', 'New car');
    return CardTagType;
}());
export var CardTagLevel;
(function (CardTagLevel) {
    CardTagLevel["Primary"] = "primary";
    CardTagLevel["Secondary"] = "secondary";
    CardTagLevel["Tertiary"] = "tertiary";
    CardTagLevel["Quaternary"] = "quaternary";
})(CardTagLevel || (CardTagLevel = {}));
export var LeaseType;
(function (LeaseType) {
    LeaseType["PERSONAL"] = "Personal";
    LeaseType["BUSINESS"] = "Business";
})(LeaseType || (LeaseType = {}));
